import { render, staticRenderFns } from "./ClinicDescriptionComponent.vue?vue&type=template&id=4396059b&"
import script from "./ClinicDescriptionComponent.vue?vue&type=script&lang=js&"
export * from "./ClinicDescriptionComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports